<div *ngIf="region">
  <div class="stick-top">
    <mat-toolbar>
      <mat-icon>terrain</mat-icon> {{!region.id ? 'Create new Secure Access Region' : ('Secure Access Region: ' + region.name)}}
    </mat-toolbar>
    <div class="hbox lightly-padded button-bar">
      <button mat-raised-button class="primary" type="button" (click)="save()">
        <mat-icon>{{!region.id ? 'add' : 'save'}}</mat-icon>
        {{(region.id ? 'Update ' : 'Add ')}}
      </button>
    </div>
  </div>

  <mat-tab-group>
    <mat-tab label="Settings">
      <div class="padded">
        <table class="basicTable vtable">
          <tbody>
          <tr *ngIf="authService.isCompanyAdmin()">
            <th>Company</th>
            <td>
              <micro-company-lookup [companyId]="region.companyId" [link]="false"></micro-company-lookup>
            </td>
          </tr>
          <tr>
            <th style="width: 80px;">Region Name</th>
            <td style="width: 200px;"><micro-region-lookup [regionId]="region.id"></micro-region-lookup></td>
          </tr>
          </tbody>
        </table>
      </div>

      <div>
        <mat-toolbar>
          <mat-icon>shield_person</mat-icon> Users
        </mat-toolbar>
        <div *ngIf="authService.isCompanyAdmin()" class="hbox lightly-padded button-bar">
          <micro-radio [options]="[{positive:'Assignable Users', negative:'Assignable Users', value:'assignableUsers'},
                                   {positive:'All Users', negative:'All Users', value:'allUsers'}
                                  ]"
                       [value]="userCriteria" (valueChange)="userCriteriaChanged($event)">
          </micro-radio>
        </div>
      </div>

      <div class="padded">
        <micro-picklist *ngIf="saUsers"
                        [all]="saUsers"
                        [(selectedIds)]="region.users"
                        displayField="plDisplayName"
                        [title]="'Users with ' + (region.name ?? '') + ' access'"
                        [availableLabel]="'Unassigned Users (Department/User)'"
                        [selectedLabel]="'Assigned Users (Department/User)'">

        </micro-picklist>
      </div>

    </mat-tab>
    <mat-tab *ngIf="region.id" label="Audit Log">
      <ng-template matTabContent>
        <micro-regionAuditLogs #auditLogs [regionId]="region.id" [contactChanges]="true"></micro-regionAuditLogs>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>


